import React from "react";
import TherapistSidebar from "./TherapistSidebar";
import "../staff/StaffLayout.css";

const TherapistLayout = ({ children }) => {
  return (
    <div className="staff-layout">
      <TherapistSidebar />
      <main className="staff-layout-content">{children}</main>
    </div>
  );
};

export default TherapistLayout;
